/* eslint-disable camelcase */
export default function spAddToWishList({ item_name, item_id, item_variant, item_parent_reporting_category, item_child_reporting_category, item_autoship, item_smartpak, price, quantity }) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'sp_add_to_wishlist',
        ecommerce: {
            items: [
                {
                    item_name,
                    item_id,
                    item_variant,
                    item_parent_reporting_category,
                    item_child_reporting_category,
                    item_autoship,
                    item_smartpak,
                    price,
                    quantity
                }
            ]
        }
    });
}

